var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "service-category-header" }, [
    _c("div", { staticClass: "title-header-text py-2" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-auto col-sm-12" },
          [
            _vm.showDropdownForActionBrowse
              ? _c("div", { staticClass: "dropdown d-inline-block" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link dropdown-btn px-0",
                      attrs: {
                        "data-toggle": "dropdown",
                        "aria-expanded": "false",
                        href: "#"
                      }
                    },
                    [
                      _c("span", { staticClass: "mr-1 nav-lnk-container" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.platformCategoryName) +
                            " Actions:\n              "
                        ),
                        _vm.serviceAreas.length == 1
                          ? _c("span", [
                              _vm._v(_vm._s(_vm.currentServiceLine.name))
                            ])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.currentServiceArea.name))
                            ])
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "category-drop-down-arrow down"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dropdown-menu container-fluid category-container",
                      attrs: { "aria-labelledby": "dropdownMenuButton" }
                    },
                    [
                      _vm.serviceAreas.length == 1
                        ? _c(
                            "div",
                            _vm._l(_vm.serviceAreas[0].serviceLines, function(
                              serviceLine
                            ) {
                              return _c(
                                "div",
                                { key: serviceLine.id },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "dropdown-item servicearea-dropdown-item",
                                      class: [
                                        serviceLine.id ===
                                        _vm.currentServiceLine.id
                                          ? "router-link-active"
                                          : ""
                                      ],
                                      attrs: {
                                        to: {
                                          name: "service-categories-by-id",
                                          params: {
                                            platformCategory:
                                              _vm.platformCategory,
                                            id: serviceLine.id
                                          }
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.clickSLRoute(serviceLine)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(serviceLine.name))]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.serviceAreas, function(servicearea) {
                              return _c(
                                "div",
                                { key: servicearea.id },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass:
                                        "dropdown-item servicearea-dropdown-item",
                                      class: [
                                        servicearea.id ===
                                        _vm.currentServiceArea.id
                                          ? "router-link-active"
                                          : ""
                                      ],
                                      attrs: {
                                        to: {
                                          name: "service-categories-by-id",
                                          params: {
                                            platformCategory:
                                              _vm.platformCategory,
                                            id: servicearea.id
                                          }
                                        }
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.clickSARoute(servicearea)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(servicearea.name))]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                    ]
                  )
                ])
              : _c("div", { staticClass: "d-inline-block" }, [
                  _c(
                    "span",
                    { staticClass: "mr-1 nav-lnk-container d-inline-block" },
                    [
                      _c("span", { staticClass: "nav-link-no-dropdown" }, [
                        _vm._v(
                          _vm._s(_vm.platformCategoryName) +
                            "\n             Actions"
                        ),
                        !_vm.isPlatformCategorySameAsServiceLine
                          ? _c("span", [
                              _vm._v(": "),
                              _vm.serviceAreas.length == 1
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.currentServiceLine.name))
                                  ])
                                : _c("span", [
                                    _vm._v(_vm._s(_vm.currentServiceArea.name))
                                  ])
                            ])
                          : _vm._e()
                      ])
                    ]
                  )
                ]),
            _vm._v(" "),
            _c("employee-hub-bookmark", {
              key: _vm.$route.params.id,
              staticClass: "eh-bookmark",
              attrs: { title: _vm.bookmarkTitle, "show-circle": "" }
            })
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-256568bf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-256568bf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service-browser/DisplayCategories.vue
// module id = null
// module chunks = 